<template>
  <div>
    <LandingNavigation :is-dark="true" />

    <section class="features full-width-div">
      <div class="container">
        <div class="col-md-5">
          <p class="uppercase">Your platform to success</p>
          <h1>Product Features</h1>
          <p class="lead" style="margin-bottom: 0">
            Explore the tools we’ve designed specifically to help you increase
            your
            <span class="underline">legal teams</span>
            productivity.
          </p>
        </div>
        <div class="d-sm-none d-none d-md-block col-md-7">
          <div class="buttons float-right">
            <!-- <button class="btn btn-primary">Sign up</button> -->
            <button
              class="request-demo"
              @click="
                $intercom.showNewMessage(
                  `Hi there. I'd like to request a demo.`
                )
              "
            >
              Request Demo
            </button>
          </div>
        </div>
      </div>
      <div class="feature-cards">
        <FeatureCard
          v-for="(feature, index) in features['legal']"
          :key="index"
          :feature="feature"
          :enable-linking="feature.enableLinking"
        />
      </div>

      <Footer />
    </section>
  </div>
</template>

<script>
import FeatureCard from "./FeatureCard.vue";
import Footer from "./Footer.vue";
import LandingNavigation from "./LandingNavigation.vue";

import features from "./features";

// import $ from "jquery";

export default {
  components: {
    FeatureCard,
    Footer,
    LandingNavigation
  },

  computed: {
    features() {
      return features;
    }
  },

  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss" scoped>
section.features {
  background: #f2f5ff;
  position: absolute;
  width: 100%;
  overflow: hidden;

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    background: #f2f5ff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .container {
    display: flex;
    align-items: flex-end;
    padding: 100px 0 50px 0;

    h1 {
      font-weight: 600;
    }

    .uppercase {
      font-size: 13px;
      letter-spacing: 1px;
      font-weight: 400;
    }
  }

  .feature-cards {
    position: relative;
    padding: 0;
    margin: 0 auto;
    align-items: center;
    justify-items: center;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 30px 0;
    max-width: 1280px;
  }

  @media (min-width: 0px) and (max-width: 800px) {
    .feature-cards {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  @media (min-width: 801px) and (max-width: 1200px) {
    .feature-cards {
      grid-template-columns: 1fr 1fr;
      max-width: 800px;
    }
  }
}
</style>
